import { render, staticRenderFns } from "./UserListFooter.vue?vue&type=template&id=db2a7c4e&scoped=true"
import script from "./UserListFooter.vue?vue&type=script&lang=ts"
export * from "./UserListFooter.vue?vue&type=script&lang=ts"
import style0 from "./UserListFooter.vue?vue&type=style&index=0&id=db2a7c4e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db2a7c4e",
  null
  
)

export default component.exports